const getNameForPictureOfAdmin = (user) => {
  let ShortName = "";
  if (user && user.name) {
    const AdminName = user.name;
    const arr = AdminName.split(" ");
    if (arr.length > 0) {
      const tempString = arr.map((element) => element[0]);
      ShortName = tempString.join("");
    }
    return ShortName;
  } else {
    return ShortName;
  }
};
export const calculateYears = (date) => {
  const birthDate = new Date(date);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const getCurrentYear = () => {
  const date = new Date();
  let currentYear = date.getFullYear();
  return currentYear;
};
export const AddProductModalTitleText = "Add Product ";

export const EditProductModalTitleText = "Edit Product Details";

export const AddHospitalModalText = "Add New Hospital";

export const EditHospitalModalText = "Edit Hospital";

export const FormTemplateModalText = "New Form template";

export const AddPrincipleInvestigatorModalText = "Add Principle Investigator";

export const EditPrincipleInvestigatorModalText = "Edit Principle Investigator";

export const AddImmunoActQAText = "Add ImmnoAct QA";

export const EditImmunoActQAText = "Edit ImmnoAct QA";

export const AddDiseaseManagementModalText = "Add New Disease";

export const EditDiseaseManagementModalText = "Edit Disease";

export const AddEditorManagementModalText = "Add Editor";

export const EditEditorManagementModalText = "Edit Editor";

export const ResendTrialManagementModalText = "Resend Request";

export const RejectTrialManagementModalText = "Description";

export const DescripitionTrialManagementModalText = "Description";

export const AddPhaseModalText = "Add New Phase";



export default getNameForPictureOfAdmin;

export const APHERESIS_FEASIBILITY_REQUESTS_PATH = "/bmr/feasibility-assessment/apheresis-requests";
export const APHERESIS_FEASIBILITY_REQUESTS_TITLE = "Apheresis Request";

/** Apheresis request patient details under Feasibility (BMR or CDM path). */
export const isApheresisFeasibilityDetailsPath = (url = "") =>
  /\/feasibility-assessment\/apheresis-requests\/details\//.test(url);

/**
 * Tasks list route: CDM header uses `/tasks`; BMR uses `/bmr/pending-tasks`.
 * portal_access: 1 = CDM, 2 = BMR only, 3 = both (use CDM `/tasks` like post-login UX).
 */
export const getPendingTasksPathForBreadcrumb = (
  pathname = "",
  portalAccess
) => {
  const pa =
    portalAccess !== undefined && portalAccess !== null && portalAccess !== ""
      ? Number(portalAccess)
      : NaN;
  if (pa === 1 || pa === 3) {
    return "/tasks";
  }
  if (pa === 2) {
    return "/bmr/pending-tasks";
  }
  return pathname.startsWith("/bmr/") ? "/bmr/pending-tasks" : "/pending-tasks";
};

/** Pure: breadcrumb list for detail routes. No React hooks — safe inside useState init. */
export const buildBreadcrumbListForDetailsRoute = (
  routeUrl,
  state,
  // portalAccess //@info commenting not using currently 
) => {
  if (state?.length > 0) {
    if (isApheresisFeasibilityDetailsPath(routeUrl)) {
      return state.map((c, i) =>
        i === 0 ? { ...c, path: APHERESIS_FEASIBILITY_REQUESTS_PATH, name: APHERESIS_FEASIBILITY_REQUESTS_TITLE } : c
      );
    }
    return state;
  }

  let spllitedUrlArray = routeUrl?.split("/").filter(Boolean);

  let bmr = false;
  if (spllitedUrlArray[0] === "bmr") {
    bmr = true;
    spllitedUrlArray = spllitedUrlArray.slice(1);
  }

  const breadcrumbs = [];
  let title = "";
  let basePath = "";

  if (spllitedUrlArray.includes("view")) {
    const index = spllitedUrlArray.indexOf("view");
    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.slice(0, index).join("/")}`;

    title = spllitedUrlArray.includes("in-bound")
      ? "LSM Inbound"
      : spllitedUrlArray.includes("out-bound")
      ? "LSM Outbound"
      : spllitedUrlArray[0].replace(/-/g, " ");
  } else if (spllitedUrlArray.includes("manufacturer_view")) {
    title = "Manufacturer";
    basePath = "/bmr/manufacturer";
  } else if (spllitedUrlArray.includes("details")) {
    const index = spllitedUrlArray.indexOf("details");
    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.slice(0, index).join("/")}`;

    title = spllitedUrlArray.includes("lsm-received")
      ? "LSM Received"
      : spllitedUrlArray.includes("approval-received")
      ? "Approved LSM"
      : spllitedUrlArray.includes("lsm")
      ? "QR Code Generation"
      : spllitedUrlArray[0].replace(/-/g, " ");

    if (
      spllitedUrlArray.includes("feasibility-assessment") &&
      spllitedUrlArray.includes("apheresis-requests")
    ) {
      basePath = APHERESIS_FEASIBILITY_REQUESTS_PATH;
      title = APHERESIS_FEASIBILITY_REQUESTS_TITLE;
    }
  } else if (
    spllitedUrlArray.includes("qc") ||
    spllitedUrlArray.includes("qa") ||
    spllitedUrlArray.includes("fb")
  ) {
    const index =
      spllitedUrlArray.indexOf("qc") >= 0
        ? spllitedUrlArray.indexOf("qc")
        : spllitedUrlArray.indexOf("qa") >= 0
        ? spllitedUrlArray.indexOf("qa")
        : spllitedUrlArray.indexOf("fb");

    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.slice(0, index + 1).join("/")}`;

    title = spllitedUrlArray.includes("qa")
      ? "Quality Approved"
      : spllitedUrlArray.includes("fb")
      ? "Form Management"
      : "Quality Control";
  } else {
    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.join("/")}`;
    title = spllitedUrlArray[0]?.replace(/-/g, " ");
  }

  if (basePath && title) {
    breadcrumbs.push({
      name: title,
      path: basePath,
    });
  }
  breadcrumbs.push({
    name: "Details",
    path: routeUrl,
  });
  return breadcrumbs;
};

/**
 * Sync location state with breadcrumb list. Call from component body with useNavigate().
 * @param navigate - from useNavigate()
 */
export const urlToBackWithoutState = (
  routeUrl,
  state,
  portalAccess,
  navigate
) => {
  const breadcrumbs = buildBreadcrumbListForDetailsRoute(
    routeUrl,
    state,
    portalAccess
  );
  if (typeof navigate === "function") {
    navigate(routeUrl, { state: breadcrumbs }, true);
  }
  return breadcrumbs;
};

export const UrlToRouteArrayConverter = (phaseDetails, routeUrl) => {
  let productDetails = phaseDetails?.product_details;
  let BreadCrumbArray = [];
  if (routeUrl) {
    let spllitedUrlArray = routeUrl?.split("/");
    spllitedUrlArray.forEach((path, index) => {
      let DetailPageBoolean = false;
      let pathobj = {};
      if (
        spllitedUrlArray[index - 1]?.length > 0 &&
        spllitedUrlArray[index].includes(spllitedUrlArray[index - 1])
      ) {
        DetailPageBoolean = true;
      }
      if (isNaN(Number(path))) {
        let splittedPathArray = path?.split("-");
        splittedPathArray = splittedPathArray?.map(
          (word) => word?.charAt(0).toUpperCase() + word?.slice(1)
        );

        let joinedPathString = splittedPathArray?.join(" ");
        if (joinedPathString === "Product Details") {
          if (productDetails?.id == spllitedUrlArray[index + 1]) {
            pathobj.name = `${productDetails?.name[0]?.toUpperCase() + productDetails?.name.slice(1) + " " || ""}Details`;
          } else {
            pathobj.name = "Details";
          }
        } else if (joinedPathString === "Trials") {
          pathobj.name = `${phaseDetails?.title || ""}`;
        }
        else if (joinedPathString === "Assigned Editors" || joinedPathString === "Editor Management") {
          pathobj.name = 'Editor';
        }
        else if (joinedPathString === "Patient Details") {
          pathobj.name = 'Patient Details';
        }
        else if (joinedPathString === "Role Details") {
          pathobj.name = 'Role Details';
        }
        else if (joinedPathString === "Feasibility Assessment") {
          pathobj.name = 'Feasibility Assessment';
        }
        else {
          if (DetailPageBoolean) {
            pathobj.name = "Details";
          } else {
            pathobj.name = joinedPathString;
          }
        }
        if (!isNaN(spllitedUrlArray[index + 1])) {
          let pathArray = spllitedUrlArray.slice(1, index + 2);
          let pathString = pathArray.join("/");
          pathobj.path = pathString;
        } else {
          pathobj.path = `${spllitedUrlArray[index]}`;
        }
        BreadCrumbArray.push(pathobj);
      }
    });
  }
  return BreadCrumbArray;
};

export const FormBreadCrumbGetter = (routeUrl, phaseDetails) => {

  let BreadCrumbArray = [];
  if (routeUrl) {
    let spllitedUrlArray = routeUrl?.split("/");
    spllitedUrlArray.forEach((path, index) => {
      let pathobj = {};
      if (isNaN(Number(path))) {
        let splittedPathArray = path?.split("-");
        splittedPathArray = splittedPathArray?.map(
          (word) => word?.charAt(0).toUpperCase() + word?.slice(1)
        );

        let joinedPathString = splittedPathArray?.join(" ");
        if (
          joinedPathString === "Create Form Builder"
        ) {
          pathobj.name = "Add New Form";
        } else if (joinedPathString === "Form Builder Preview") {
          pathobj.name = "Preview";
        } else if (joinedPathString === "Product Details") {
          if (phaseDetails)
            pathobj.name = phaseDetails?.product_details?.name + " Details";
        }
        else {
          pathobj.name = joinedPathString;
        }
        if (!isNaN(spllitedUrlArray[index + 1])) {
          let pathArray = spllitedUrlArray.slice(1, index + 2);
          let pathString = pathArray.join("/");
          pathobj.path = pathString;
        } else {
          pathobj.path = `${spllitedUrlArray[index]}`;
        }
        BreadCrumbArray.push(pathobj);
      }
    });
  }
  return BreadCrumbArray;
};

export const generateCountArray = (count) => {
  return Array.from({ length: count }, (_, i) => ({
    label: i + 1,
    value: i + 1
  }));
};